import React from 'react';
import Products from '../components/Products';

const ProductsPage: React.FC = () => {
  return (
    <div style={{ paddingTop: '80px' }}>
      <Products />
    </div>
  );
};

export default ProductsPage;
